<template>
    <div class="review-stars">
        <svg
            style="width: 0; height: 0;"
            viewBox="0 0 156.64 105.37"
        >
            <defs>
                <!-- for partial stars -->
                <linearGradient :id="uuid + '-partial'" x1="0" x2="100%" y1="0" y2="0">
                    <stop :offset="partial + '%'" :stop-color="fillColor"></stop>
                    <stop :offset="partial + '%'" :stop-color="baseColor"></stop>
                </linearGradient>

                <!-- reusable star shape -->
                <symbol id="review-star" viewBox="0 0 156.64 105.37">
                    <path
                        d="m126.83 127.09-48.432-25.394-48.376 25.501 9.1845-53.909-39.202-38.128 54.109-7.9238 24.148-49.066 24.256 49.012 54.126 7.8036-39.117 38.215z"
                    />
                </symbol>
            </defs>
        </svg>
        <svg :style="starStyle">
            <use xlink:href="#review-star" :fill="starOne"></use>
        </svg>
        <svg :style="starStyle">
            <use xlink:href="#review-star" :fill="starTwo"></use>
        </svg>
        <svg :style="starStyle">
            <use xlink:href="#review-star" :fill="starThree"></use>
        </svg>
        <svg :style="starStyle">
            <use xlink:href="#review-star" :fill="starFour"></use>
        </svg>
        <svg :style="starStyle">
            <use xlink:href="#review-star" :fill="starFive"></use>
        </svg>
       <span v-if="numReviews" class="numReviews">{{numReviews}} {{ numReviews == 1 ? 'Review' : 'Reviews' }}</span>
       <span v-if="numQuestions" class="numReviews">{{numQuestions}} {{ numQuestions == 1 ? 'Q&A' : 'Q&As'}}</span> 
    </div>

</template>

<script src="./ctrl-review-stars.js"></script>
